const system = {
    namespaced: true,
    state: {
        version: '',
    },
    mutations: {
        set_version: (state, version) => {
            state.version = version
        },
    },
    actions: {
        setVersion({commit},data) {
            commit('set_version',data)
        }, 
    }
}
export default system
